import { Inject, Injectable } from '@angular/core';
import { CrudService } from '@services/firestore-crud.service';
import { Firestore } from 'firebase/firestore';
import { FirebaseStorage } from 'firebase/storage';
import { FIRESTORE_TOKEN, STORAGE_TOKEN } from './firebase.tokens';

export enum SongType {
  patriot = 'patriot',
  love = 'love',
  children = 'children',
  elegy = 'elegy',
  satire = 'satire',
  epic = 'epic',
  nature = 'nature',
  holiday = 'holiday',
  other = 'other',
}

export interface Song {
  id?: string;
  innerHtml: string | null;
  slug: string | null;
  title: string | null;
  type: SongType | null;
  authorSlug: string | null;
  authorName: string | null;
  important: boolean | null;
  created: number | null;
  updated: number | null;
}

export interface SongTypeOption {
  id: SongType;
  name: string;
}

export const songTypes: SongTypeOption[] = [
  { id: SongType.patriot, name: 'Родољубива поезија' },
  { id: SongType.love, name: 'Љубавнa поезија' },
  { id: SongType.children, name: 'Дечја поезија' },
  { id: SongType.elegy, name: 'Елегија' },
  { id: SongType.satire, name: 'Сатира' },
  { id: SongType.epic, name: 'Епска поезија' },
  { id: SongType.nature, name: 'Лирска поезија' },
  { id: SongType.holiday, name: 'Празнична поезија' },
];

@Injectable({ providedIn: 'root' })
export class SongsService extends CrudService<Song> {
  override collectionName = 'songs';

  constructor(
    @Inject(FIRESTORE_TOKEN) firestore: Firestore,
    @Inject(STORAGE_TOKEN) storage: FirebaseStorage
  ) {
    super(firestore, storage);
  }
}
